/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type SbRespTradeOnApprovalPromoBanner_searchBrowse = {| |};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespTradeOnApprovalPromoBanner_searchBrowse",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbRespTradeOnApprovalPromoLocationFilter_searchBrowse",
      "args": null
    }
  ],
  "type": "SearchBrowseQueryConnection"
};

module.exports = fragment;
